import React from 'react';
import { Accordion, Col, Image, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Learning.css';
import Check from '../../../assets/images/check.png';

const COIAccordionAction = ({
  content,
  title,
  isCompleted,
  eventKey
}: {
  content: any;
  title: string;
  isCompleted: boolean;
  eventKey: string;
}) => {
  return (
    <>
      <Accordion.Item eventKey={eventKey}>
        <Accordion.Header>
          <Row style={{ flex: 1 }}>
            <Col xs='auto' style={styles.title}>
              {title}
            </Col>
            {isCompleted && (
              <Col xs='auto' className='ms-auto me-1'>
                <Image
                  className='d-block'
                  style={styles.img2}
                  src={Check}
                />
              </Col>
            )}
          </Row>
        </Accordion.Header>
        <Accordion.Body className='py-0'>{content}</Accordion.Body>
      </Accordion.Item>
    </>
  );
};

const styles: any = {
  title: {
    fontFamily: 'Saira',
    fontSize: '16px',
    fontWeight: '500',
    color: '#242424'
  },
  img2: {
    width: '23px',
    height: '23px'
  }
};

export default COIAccordionAction;
